import get from 'lodash/get';

export const rootSiteState = (state) => get(state, 'rootSite', {});
export const contentsSiteState = (state) => get(state, 'contentsSite', {});
export const userState = (state) => get(state, 'user', {});

export const getContentHelper = (content) => content || {};
